import { api } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import { startOfWeek } from 'date-fns';

export function useObjectiveAttendeeCounts(objectiveId, groupType, groupId) {
  return useQuery({
    queryKey: ['topFiveObjectiveAttendees', objectiveId, groupType, groupId],
    queryFn: () => {
      const weekStart = import.meta.env.DEV
        ? new Date('2000-01-01')
        : startOfWeek(new Date());
      const json = [
        {
          $match: {
            startTime: { $gt: weekStart },
            'objective.identifier': objectiveId,
            [`person.groups.${groupType}`]: groupId,
          },
        },
        {
          $group: {
            _id: '$person.collarNumber',
            attendances: { $sum: 1 },
            durationSeconds: { $sum: '$durationSeconds' },
          },
        },
        {
          $project: {
            _id: false,
            collarNumber: '$_id',
            attendances: true,
            durationSeconds: true,
          },
        },
        { $sort: { durationSeconds: -1 } },
      ];

      return api.post('pipeline/personObjectiveAttendances', { json }).json();
    },
    placeholderData: [],
  });
}
